// Import Libraries
import React from 'react';
import { createRoot } from 'react-dom/client';
// Import JS Modules
import 'Utils/login-launcher';
import Loader from '../customer_pages/_photo-loader/photo-loader';
import '../customer_pages/_libs/analytics/checkout-google-analytics.js';
import '../customer_pages/_photo-loader/photo-loader-omni-analytics';

// Render Loader
createRoot(document.getElementById('image-loader')).render(<Loader />);

// This is a hack to prevent iPad scroll failure
// because <iframe> elements derive their height from child document content
// which varies to zero on dom refresh under certain circumstances.
//
// 0 height automatically resets scrollTop property to 0, which persists
// even when iframe height is recalculated.
// This sets height on iframe element in parent page explicitly, so iframe
// height never varies to zero, even if the content does.

if (/iPad|iPhone|iPod/.test(navigator.platform)) {
  window.addEventListener('message', msg => {
    if (msg.data && msg.data.freize_height) {
      const h = msg.data.freize_height;
      const activeIframe = $(
        '.image-loader-service:visible .iframe-container iframe'
      );
      activeIframe.css('height', h);
    }
  });
}
